import errorLoggingService from '@/services/error.logging.service'

export default errorLoggingService.getReactErrorBoundary()
